// @flow

import createPutawayItemQuantitiesTableColumn from './components/table/PutawayItemQuantitiesTableColumn';

import supplySelectorFieldConfiguration from './components/configuration/supplySelectorFieldConfiguration';
import receiptSelectorFieldConfiguration from './components/configuration/receiptSelectorFieldConfiguration';
import transferSelectorFieldConfiguration from './components/configuration/transferSelectorFieldConfiguration';

import putawaySourceSelectorFieldConfiguration from './components/configuration/putawaySourceSelectorFieldConfiguration';
import putawaySourceItemSelectorFieldConfiguration from './components/configuration/putawaySourceItemSelectorFieldConfiguration';

export const components = {
    'tableColumn:putawayItemQuantities': createPutawayItemQuantitiesTableColumn,

    'configuration:trix-web-plugin-wms-putaway.managePutawayPage.container.putawayItemsTable.action.onAddItemFromSource.editor._.putawaySource': putawaySourceSelectorFieldConfiguration,
    'configuration:trix-web-plugin-wms-putaway.managePutawayPage.container.putawayItemsTable.action.onAddItemFromSource.editor._.putawaySourceItem': putawaySourceItemSelectorFieldConfiguration,

    'configuration:trix-web-plugin-wms-putaway.managePutawayPage.container.putawaySourcesTable.action.onAttachSupply.editor._.supply': supplySelectorFieldConfiguration,
    'configuration:trix-web-plugin-wms-putaway.managePutawayPage.container.putawaySourcesTable.action.onAttachReceipt.editor._.receipt': receiptSelectorFieldConfiguration,
    'configuration:trix-web-plugin-wms-putaway.managePutawayPage.container.putawaySourcesTable.action.onAttachTransfer.editor._.transfer': transferSelectorFieldConfiguration,
}
